import {Decimal} from 'decimal.js';
import * as _ from 'lodash-es';

export const normalizeVwapSizes = (vwapSizes: number[] | undefined) =>
    vwapSizes
        ? _.uniq(vwapSizes)
            .filter(Boolean)
            .sort((v1, v2) => v1 - v2)
        : vwapSizes;

/**
 * Converts number to string without exponential notation: not "1e-8", but "0.00000001".
 */
export const vwapSizeToStr = (vwapSize: number): string =>
    new Decimal(vwapSize).toFixed();
